import {
    initMain
} from './vue/controllers/main';
import {
    header
} from './vue/controllers/header';
import {
    insideHomeMixin
} from './vue/mixins/inside';
import lazyload from './features/lazy-load';
import {
    CarouselPlugin
} from 'bootstrap-vue';
import {
    TimelineLite
} from 'gsap';

const a = new TimelineLite();
lazyload();

initMain([insideHomeMixin], {}, [
    CarouselPlugin
]);
header();